import data0 from './00_example.json';
import data1 from './01_simplest_possible.json';
import data2 from './02_two_users.json';
import data3 from './03_five_users.json';
import data4 from './04_one_interferer.json';
import data5 from './05_equatorial_plane.json';
import data6 from './06_partially_fullfillable.json';
import data7 from './07_eighteen_planes.json';
import data8 from './08_eighteen_planes_northern.json';
import data9 from './09_ten_thousand_users.json';
import data10 from './10_ten_thousand_users_geo_belt.json';
import data11 from './11_one_hundred_thousand_users.json';

const files = {
  "00_example": data0,
  "01_simplest_possible": data1,
  "02_two_users": data2,
  "03_five_users": data3,
  "04_one_interferer": data4,
  "05_equatorial_plane": data5,
  "06_partially_fullfillable": data6,
  "07_eighteen_planes": data7,
  "08_eighteen_planes_northern": data8,
  "09_ten_thousand_users": data9,
  "10_ten_thousand_users_geo_belt": data10,
  "11_one_hundred_thousand_users": data11,
};

export default files;
